import { BarChart3 } from "lucide-react";

const PerformanceTab = () => (
  <div className="rounded-xl border p-12 text-center"
    style={{ background: "hsl(0 0% 6%)", borderColor: "hsl(0 0% 14%)" }}>
    <BarChart3 size={28} className="mx-auto mb-3" style={{ color: "hsl(0 0% 35%)" }} />
    <p className="text-base font-medium" style={{ color: "hsl(0 0% 80%)" }}>Performance attribution, P2</p>
    <p className="text-sm mt-1 max-w-md mx-auto" style={{ color: "hsl(0 0% 55%)" }}>
      Per-article impressions, clicks, CTR, position, page views, and lead attribution
      will appear here once the nightly GSC sync and visitor → lead joiner ship in Phase 2.
      Until then, use <strong>Search Performance</strong> for live GSC queries.
    </p>
  </div>
);

export default PerformanceTab;
